import { BridgeComponent } from "@hotwired/hotwire-native-bridge";

// Renders a native navigation-bar button (e.g. "Save", "Add", "Done") from a
// web element. Tapping the native button clicks the underlying web control, so
// the existing Rails form/link handling stays authoritative.
//
//   %button.ui.button{data: { controller: "bridge--button",
//                             "bridge-button-title-value": "Add" }} Add
export default class extends BridgeComponent {
  static component = "button";
  static values = { title: String, side: { type: String, default: "right" } };

  connect() {
    super.connect();
    this.send(
      "connect",
      { title: this.titleValue, side: this.sideValue },
      () => {
        this.element.click();
      }
    );
  }
}
